export const STRINGS = {
  YOUR_PASSWORD_FOLLOWING: 'Your password must have the following:',
  CHARACTERS_IN_LENGTH: 'Characters in length',
  SUCH_AS: 'such as ! # % @',
  NEW_PASSWORD: 'New Password',
  CONFIRM_NEW_PASSWORD: 'Confirm New Password',
  RESET_PASSWORD: 'Reset Password',
  SET_PASSWORD: 'Set Password',
};
